module.exports = __webpack_public_path__ + "static/img/cont37_08.7415401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_08.jpg
// module id = sUFw
// module chunks = 0